module.exports = __webpack_public_path__ + "static/assets/7f80aa89caeea2a0f637c6908c63f8c7.svg";